import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, Form, InputGroup, Row, Col, Card, Alert } from 'react-bootstrap';
import { FaPlay, FaPause, FaStop, FaBell, FaClock, FaRedo, FaHourglassStart } from 'react-icons/fa';

const Hatirlatici = () => {
  // Sayfa ilk açıldığında başlangıç saatini otomatik olarak şu anki saat yapar
  const [baslangicSaati, setBaslangicSaati] = useState(() => {
    const now = new Date();
    return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
  });
  const [bitisSaati, setBitisSaati] = useState("19:00");
  const [aralik, setAralik] = useState(10);
  const [mesaj, setMesaj] = useState("Düzenli kontrol vaktiniz geldi!");
  
  const [isActive, setIsActive] = useState(false);
  const [loglar, setLoglar] = useState([]);
  
  const timerRef = useRef(null);
  const sonrakiTetiklenme = useRef(null);

  // Tarayıcıdan bildirim izni iste
  useEffect(() => {
    if ("Notification" in window && Notification.permission !== "granted" && Notification.permission !== "denied") {
      Notification.requestPermission();
    }
    return () => clearInterval(timerRef.current);
  }, []);

  const ekleLog = useCallback((yeniLog) => {
    setLoglar((prev) => [`[${new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second:'2-digit'})}] ${yeniLog}`, ...prev]);
  }, []);

  const bildirimGonder = useCallback((baslik, icerik) => {
    if ("Notification" in window && Notification.permission === "granted") {
      new Notification(baslik, { body: icerik });
    } else if ("Notification" in window && Notification.permission !== "denied") {
      Notification.requestPermission().then(permission => {
        if (permission === "granted") new Notification(baslik, { body: icerik });
      });
    }
  }, []);

  const toggleHatirlatici = useCallback(() => {
    if (isActive) {
      setIsActive(false);
      clearInterval(timerRef.current);
      ekleLog("Hatırlatıcı duraklatıldı.");
      return;
    }

    if (!baslangicSaati || !bitisSaati || aralik <= 0) {
      alert("Lütfen geçerli başlangıç/bitiş saatleri ve dakika aralığı girin.");
      return;
    }

    setIsActive(true);
    ekleLog(`Hatırlatıcı kuruldu. ${baslangicSaati} - ${bitisSaati} arasında ${aralik} dakikada bir çalışacak.`);
    
    const simdi = new Date();
    
    // Başlangıç saatini Date objesine çevir
    const [bSaat, bDakika] = baslangicSaati.split(":");
    const basTarihi = new Date();
    basTarihi.setHours(parseInt(bSaat, 10), parseInt(bDakika, 10), 0, 0);

    // İlk tetiklenme zamanının belirlenmesi
    if (simdi < basTarihi) {
      // Başlangıç saeti gelecekteyse, ilk bildirim tam başlangıç saatinde çalar
      sonrakiTetiklenme.current = basTarihi;
    } else {
      // Başlangıç saati şu an veya geçmişse, ilk bildirim 'aralik' dakika sonra çalar
      sonrakiTetiklenme.current = new Date(simdi.getTime() + aralik * 60000);
    }

    timerRef.current = setInterval(() => {
      const suAn = new Date();
      
      // Döngü içinde güncel tarih sınırlarını hesapla
      const [basSaat, basDakika] = baslangicSaati.split(":");
      const loopBasTarihi = new Date();
      loopBasTarihi.setHours(parseInt(basSaat, 10), parseInt(basDakika, 10), 0, 0);

      const [bitisSaat, bitisDakika] = bitisSaati.split(":");
      const loopBitisTarihi = new Date();
      loopBitisTarihi.setHours(parseInt(bitisSaat, 10), parseInt(bitisDakika, 10), 0, 0);

      // 1. Kontrol: Bitiş saatine ulaşıldı mı?
      if (suAn >= loopBitisTarihi) {
        setIsActive(false);
        clearInterval(timerRef.current);
        ekleLog("Bitiş saatine ulaşıldı, görev tamamlandı.");
        bildirimGonder("✅ Hatırlatıcı Tamamlandı", "Belirlediğiniz bitiş saatine ulaştık.");
        return;
      }

      // 2. Kontrol: Başlangıç saati geldi mi ve periyodik süre doldu mu?
      if (suAn >= loopBasTarihi && suAn >= sonrakiTetiklenme.current) {
        const saatMetni = suAn.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
        bildirimGonder("🔔 Zaman Geldi!", `Saat: ${saatMetni} - ${mesaj}`);
        ekleLog(`Bildirim gönderildi (${saatMetni}).`);
        
        // Bir sonraki tetiklenme vaktini planla
        sonrakiTetiklenme.current = new Date(suAn.getTime() + aralik * 60000);
      }
    }, 1000);
  }, [isActive, baslangicSaati, bitisSaati, aralik, mesaj, ekleLog, bildirimGonder]);

  const resetHatirlatici = useCallback(() => {
    setIsActive(false);
    clearInterval(timerRef.current);
    setLoglar([]);
    ekleLog("Sistem sıfırlandı.");
  }, [ekleLog]);

  // Dinamik durum mesajı fonksiyonu
  const getDurumTipi = () => {
    if (!isActive) return { variant: "secondary", text: "⚪ Beklemede" };
    const suAn = new Date();
    const [bSaat, bDakika] = baslangicSaati.split(":");
    const basTarihi = new Date();
    basTarihi.setHours(parseInt(bSaat, 10), parseInt(bDakika, 10), 0, 0);

    if (suAn < basTarihi) return { variant: "info", text: "⏳ Başlangıç Saati Bekleniyor..." };
    return { variant: "success", text: "🟢 Aktif (Arka planda çalışıyor)" };
  };

  const durum = getDurumTipi();

  return (
    <div className="container py-4">
      <Card className="shadow-sm mx-auto" style={{ maxWidth: '850px', borderRadius: '15px' }}>
        <Card.Header className="text-center bg-primary text-white" style={{ borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}>
          <h4 className="mb-0"><FaBell className="me-2 mb-1" /> Canlı Hatırlatıcı</h4>
        </Card.Header>
        
        <Card.Body className="p-4">
          <Row>
            {/* Ayarlar Kolonu */}
            <Col lg={6} className="mb-4 mb-lg-0">
              <Form>
                {/* Başlangıç ve Bitiş Saatleri Yan Yana */}
                <Row className="g-2 mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold"><FaHourglassStart className="me-1 text-success" /> Başlangıç Saati</Form.Label>
                      <Form.Control 
                        type="time" 
                        value={baslangicSaati} 
                        onChange={(e) => setBaslangicSaati(e.target.value)}
                        disabled={isActive}
                        size="lg"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className="fw-bold"><FaClock className="me-1 text-danger" /> Bitiş Saati</Form.Label>
                      <Form.Control 
                        type="time" 
                        value={bitisSaati} 
                        onChange={(e) => setBitisSaati(e.target.value)}
                        disabled={isActive}
                        size="lg"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold"><FaRedo className="me-1" /> Aralık (Dakika)</Form.Label>
                  <InputGroup size="lg">
                    <Form.Control 
                      type="number" 
                      value={aralik} 
                      onChange={(e) => setAralik(Number(e.target.value))}
                      min="1"
                      disabled={isActive}
                    />
                    <InputGroup.Text>DK</InputGroup.Text>
                  </InputGroup>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="fw-bold">Bildirim Mesajı</Form.Label>
                  <Form.Control 
                    type="text" 
                    value={mesaj} 
                    onChange={(e) => setMesaj(e.target.value)}
                    disabled={isActive}
                    placeholder="Örn: Su içmeyi unutma!"
                  />
                </Form.Group>

                <div className="d-flex gap-2">
                  <Button 
                    variant={isActive ? "warning" : "success"} 
                    className="flex-grow-1" 
                    size="lg"
                    onClick={toggleHatirlatici}
                  >
                    {isActive ? <><FaPause /> Duraklat</> : <><FaPlay /> Başlat</>}
                  </Button>
                  <Button 
                    variant="danger" 
                    size="lg"
                    onClick={resetHatirlatici}
                  >
                    <FaStop /> Sıfırla
                  </Button>
                </div>
              </Form>
            </Col>

            {/* Durum ve Log Kolonu */}
            <Col lg={6} className="d-flex flex-column">
              <Alert variant={durum.variant} className="text-center mb-3 fw-bold transition-all">
                Durum: {durum.text}
              </Alert>

              <div className="flex-grow-1 border rounded p-3" style={{ backgroundColor: '#f8f9fa' }}>
                <h6 className="fw-bold border-bottom pb-2 mb-2 text-muted">İşlem Kayıtları</h6>
                <div style={{ maxHeight: '250px', overflowY: 'auto', fontSize: '0.9rem' }}>
                  {loglar.length === 0 ? (
                    <p className="text-muted text-center mt-4">Henüz kayıt yok.</p>
                  ) : (
                    loglar.map((log, index) => (
                      <div key={index} className="text-secondary mb-1 border-bottom border-light pb-1">
                        {log}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      
      <div className="text-center text-muted mt-3 small">
        * Bildirimlerin arka planda tetiklenebilmesi için bu sekmenin açık kalması yeterlidir.
      </div>
    </div>
  );
};

export default Hatirlatici;